import React from 'react';

import { dateFNS } from '@gogame/intl-ts';
import { Filter } from '@gogame/filters';

import {
  CREATED_PERIOD_PRESETS,
  FILTER_CREATED,
  FILTER_APPLICATIONS,
  FILTER_DOMAINS,
  FILTER_LOCALES,
  FILTER_FLOWS,
  FILTER_PLATFORMS,
  FILTER_TAGS,
  FILTER_NETWORKS,
  FILTER_USED_IN_ADS,
  FILTER_IS_NEW,
} from 'scenes/Gallery/ConversionPages/constants';
import {
  loadApplications,
  loadDomains,
  loadLocales,
  loadFlows,
  loadPlatforms,
  loadTags,
  loadNetworks,
  loadUsedInAds,
  loadIsNew,
} from 'scenes/Gallery/ConversionPages/sources/filters';

export const Created = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Created'}
      name={FILTER_CREATED}
      timeZone={'utc'}
      placeholder={'Select period'}
      presets={CREATED_PERIOD_PRESETS}
      maxDate={dateFNS.endOfYear(new Date())}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={loadApplications}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Networks = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={loadNetworks}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Domains = (props) => {
  return (
    <Filter.MultiSelect
      title={'Domains'}
      name={FILTER_DOMAINS}
      source={loadDomains}
      placeholder={'All'}
      depends={[FILTER_PLATFORMS]}
      {...props}
    />
  );
};

export const Locales = (props) => {
  return (
    <Filter.MultiSelect
      title={'Locales'}
      name={FILTER_LOCALES}
      source={loadLocales}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Flows = (props) => {
  return (
    <Filter.MultiSelect
      title={'Flows'}
      name={FILTER_FLOWS}
      source={loadFlows}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Platforms = (props) => {
  return (
    <Filter.MultiSelect
      title={'Platforms'}
      name={FILTER_PLATFORMS}
      source={loadPlatforms}
      depends={[FILTER_NETWORKS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Tags = (props) => {
  return (
    <Filter.MultiSelect
      title={'Tags'}
      name={FILTER_TAGS}
      source={loadTags}
      placeholder={'All'}
      {...props}
    />
  );
};

export const UsedInAds = (props) => {
  return (
    <Filter.Select
      title={'Used in Ads'}
      name={FILTER_USED_IN_ADS}
      source={loadUsedInAds}
      withAll={false}
      placeholder={'All'}
      {...props}
    />
  );
};

export const IsNew = (props) => {
  return (
    <Filter.Select
      title={'New'}
      name={FILTER_IS_NEW}
      source={loadIsNew}
      placeholder={'All'}
      {...props}
    />
  );
};
